import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);

  const notifications = [
    { id: 1, text: 'اختبار الرياضيات المتقدمة متاح الآن', time: 'منذ 5 دقائق', unread: true },
    { id: 2, text: 'تم نشر نتيجة اختبار الفيزياء', time: 'منذ ساعة', unread: true },
    { id: 3, text: 'تذكير: اختبار الكيمياء غداً', time: 'منذ 3 ساعات', unread: false }
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => navigate('/home')}
          >
            <div className="w-10 h-10 flex items-center justify-center bg-[#0F2A3A] rounded-xl">
              <i className="ri-file-list-3-line text-xl text-[#1ABC9C]"></i>
            </div>
            <span className="text-xl font-bold text-[#0F2A3A]">منصة التقييم</span>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-6">
            <button
              onClick={() => navigate('/home')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isActive('/home')
                  ? 'bg-[#1ABC9C] text-white'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <i className="ri-home-line text-lg"></i>
              الرئيسية
            </button>

            <button
              onClick={() => navigate('/exams')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isActive('/exams')
                  ? 'bg-[#1ABC9C] text-white'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <i className="ri-file-list-3-line text-lg"></i>
              الاختبارات
            </button>

            <button
              onClick={() => navigate('/results')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isActive('/results')
                  ? 'bg-[#1ABC9C] text-white'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <i className="ri-bar-chart-box-line text-lg"></i>
              النتائج
            </button>

            <button
              onClick={() => navigate('/profile')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isActive('/profile')
                  ? 'bg-[#1ABC9C] text-white'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              <i className="ri-user-line text-lg"></i>
              الملف الشخصي
            </button>

            {/* Notifications */}
            <div className="relative">
              <button
                onClick={() => setShowNotifications(!showNotifications)}
                className="relative w-10 h-10 flex items-center justify-center bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors cursor-pointer"
              >
                <i className="ri-notification-3-line text-xl text-slate-600"></i>
                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                  2
                </span>
              </button>

              {showNotifications && (
                <div className="absolute left-0 mt-2 w-80 bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden">
                  <div className="p-4 bg-[#0F2A3A] text-white font-bold">
                    الإشعارات
                  </div>
                  <div className="max-h-96 overflow-y-auto">
                    {notifications.map((notif) => (
                      <div
                        key={notif.id}
                        className={`p-4 border-b border-slate-100 hover:bg-slate-50 transition-colors cursor-pointer ${
                          notif.unread ? 'bg-blue-50' : ''
                        }`}
                      >
                        <div className="flex items-start gap-3">
                          <div className="w-2 h-2 mt-2 bg-[#1ABC9C] rounded-full"></div>
                          <div className="flex-1">
                            <p className="text-sm text-slate-800 mb-1">{notif.text}</p>
                            <span className="text-xs text-slate-500">{notif.time}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-3 text-center border-t border-slate-200">
                    <button className="text-sm text-[#1ABC9C] hover:text-[#16a085] font-semibold whitespace-nowrap cursor-pointer">
                      عرض جميع الإشعارات
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
